export const MelissaStatusCodes = {
  AS01: {
    shortDescription: "Valid Address",
    longDescription:
      "The address is valid and deliverable according to official postal agencies.",
  },
  AS02: {
    shortDescription: "Valid Building Address",
    longDescription:
      "The building address was verified but the suite/apartment number is missing or invalid.",
  },
  AS03: {
    shortDescription: "Non USPS Address Match",
    longDescription:
      "US Only. This US address is not serviced by the USPS but does exist and may receive mail through third-party carriers like UPS.",
  },
  AS09: {
    shortDescription: "Foreign Address",
    longDescription: "The address is in a non-supported country.",
  },
  AS10: {
    shortDescription: "CMRA Address",
    longDescription:
      "US Only. The address is a Commercial Mail Receiving Agency (CMRA) like a Mailboxes Etc. These addresses include a Private Mail Box (PMB or #) number.",
  },
  AS11: {
    shortDescription: "PBSA Address",
    longDescription:
      "A PO Box formatted as a street address for package and mail delivery.",
  },
  AS12: {
    shortDescription: "Moved to New Address",
    longDescription: "The record moved to a new address.",
  },
  AS13: {
    shortDescription: "Address Updated By LACS",
    longDescription:
      "US Only. The address has been converted by LACSLink® from a rural-style address to a city-style address.",
  },
  AS14: {
    shortDescription: "Suite Appended",
    longDescription:
      "US Only. A suite was appended by SuiteLink™ using the address and company name.",
  },
  AS15: {
    shortDescription: "Apartment Appended",
    longDescription:
      "An apartment number was appended by AddressPlus using the address and last name.",
  },
  AS16: {
    shortDescription: "Vacant Address",
    longDescription:
      "US Only. The address has been unoccupied for more than 90 days.",
  },
  AS17: {
    shortDescription: "No USPS Mail Delivery",
    longDescription:
      "This address is classified as not receiving mail by the USPS via their No-Stat flag. Delivery might still be possible by third-party carriers but that cannot be counted on.",
  },
  AS18: {
    shortDescription: "DPV Locked Out",
    longDescription:
      "US Only. DPV processing was terminated due to the detection of what is determined to be an artificially created address.",
  },
  AS20: {
    shortDescription: "Deliverable only by USPS",
    longDescription:
      "US Only. This address can only receive mail delivered through the USPS (i.e. PO Box or a military address).",
  },
  AS22: {
    shortDescription: "No Alternate Address Suggestion Found",
    longDescription:
      "No alternate address suggestion was found for this address.",
  },
  AS23: {
    shortDescription: "Extraneous Information",
    longDescription:
      "Extraneous information not used in verifying the address was found. This includes unnecessary sub premises and other unrecognized data. Additional information will either be parsed into the Suite or Parsed Garbage/AddressExtras output.",
  },
  AS24: {
    shortDescription: "USPS Door Not Accessible",
    longDescription:
      "Address identified by the USPS where carriers cannot physically access a building or door for mail delivery.",
  },
  AE01: {
    shortDescription: "Postal Code Error/General Error",
    longDescription:
      "The address could not be verified at least up to the postal code level.",
  },
  AE02: {
    shortDescription: "Unknown Street",
    longDescription:
      "Could not match the input street to a unique street name. Either no matches or too many matches found.",
  },
  AE03: {
    shortDescription: "Component Mismatch Error",
    longDescription:
      "The combination of directionals (N, E, SW, etc) and the suffix (AVE, ST, BLVD) is not correct and produced multiple possible matches.",
  },
  AE04: {
    shortDescription: "Non-Deliverable Address",
    longDescription:
      "US Only. A physical plot exists but is not a deliverable address. One example might be a railroad track or river running alongside this street, as they would prevent the construction of homes in that location.",
  },
  AE05: {
    shortDescription: "Multiple Match",
    longDescription:
      "The address was matched to multiple records. There is not enough information available in the address to break the tie between multiple records.",
  },
  AE06: {
    shortDescription: "Early Warning System",
    longDescription:
      "US Only. This address currently cannot be verified but was identified by the Early Warning System (EWS) as belonging to an upcoming area and will likely be included in a future update.",
  },
  AE07: {
    shortDescription: "Missing Minimum Address",
    longDescription:
      "Minimum requirements for the address to be verified are not met. A country input is required for global products. For US/CA, a postal code or city/state are required. Requirements for other countries may be different.",
  },
  AE08: {
    shortDescription: "Sub Premise Number Invalid",
    longDescription:
      "An address element after the house number, in most cases the sub-premise, was not valid.",
  },
  AE09: {
    shortDescription: "Sub Premise Number Missing",
    longDescription:
      "An address element after the house number, in most cases the sub-premise, was missing.",
  },
  AE10: {
    shortDescription: "Premise Number Invalid",
    longDescription:
      "The premise (house or building) number for the address is not valid.",
  },
  AE11: {
    shortDescription: "Premise Number Missing",
    longDescription:
      "The premise (house or building) number for the address is missing.",
  },
  AE12: {
    shortDescription: "Box Number Invalid",
    longDescription:
      "The PO (Post Office Box), RR (Rural Route), or HC (Highway Contract) Box number is invalid.",
  },
  AE13: {
    shortDescription: "Box Number Missing",
    longDescription:
      "The PO (Post Office Box), RR (Rural Route), or HC (Highway Contract) Box number is missing.",
  },
  AE14: {
    shortDescription: "PMB Number Missing",
    longDescription:
      "US Only. The address is a Commercial Mail Receiving Agency (CMRA), and the Private Mail Box (PMB or #) number is missing.",
  },
  AE15: {
    shortDescription: "Demo Mode",
    longDescription:
      "Limited to Demo Mode operation. Please contact a Melissa Data CSR at 1-800-800-6245 x4.",
  },
  AE16: {
    shortDescription: "Expired Database",
    longDescription:
      "The Database has expired. Please contact a Melissa Data CSR at 1-800-800-6245 x4.",
  },
  AE17: {
    shortDescription: "Sub Premise Not Required (Deprecated - See AS23)",
    longDescription:
      "A sub-premise (suite) number was entered, but the address does not have secondaries. (Deprecated - See AS23)",
  },
  AE19: {
    shortDescription: "Find Suggestion Timeout",
    longDescription: "The FindSuggestion function has exceeded the time limit.",
  },
  AE20: {
    shortDescription: "Find Suggestion Disabled",
    longDescription:
      "The FindSuggestion function is disabled. See the manual for further details.",
  },
  AE21: {
    shortDescription: "MAK Not Found",
    longDescription:
      "The input MAK was not found. This can be caused by an improperly formatted MAK (a proper MAK is 10 numerical digits long) or by requesting a MAK number that has not yet been assigned to a location.",
  },
  AC01: {
    shortDescription: "Postal Code Change",
    longDescription: "The postal code was changed or added.",
  },
  AC02: {
    shortDescription: "Administrative Area Change",
    longDescription:
      "The administrative area (state, province) was added or changed.",
  },
  AC03: {
    shortDescription: "Locality Change",
    longDescription:
      "The locality (city, municipality) name was added or changed.",
  },
  AC04: {
    shortDescription: "Alternate to Base Change",
    longDescription:
      "US Only. The address was found to be an alternate record and changed to the base (preferred) version.",
  },
  AC05: {
    shortDescription: "Alias Name Change",
    longDescription:
      "US Only. An alias is a common abbreviation for a long street name, such as “MLK Blvd” for “Martin Luther King Blvd.” This change code indicates that the full street name (preferred) has been substituted for the alias.",
  },
  AC06: {
    shortDescription: "Address1/Address2 Swap",
    longDescription:
      "Address1 was swapped with Address2 because Address1 could not be verified and Address2 could be verified.",
  },
  AC07: {
    shortDescription: "Address1 & Company Swapped",
    longDescription:
      "Address1 was swapped with Company because only Company had a valid address.",
  },
  AC08: {
    shortDescription: "Plus4 Change",
    longDescription: "US Only. A non-empty plus4 was changed.",
  },
  AC09: {
    shortDescription: "Dependent Locality Change",
    longDescription: "The dependent locality (urbanization) was changed.",
  },
  AC10: {
    shortDescription: "Thoroughfare Name Change",
    longDescription:
      "The thoroughfare (street) name was added or changed due to a spelling correction.",
  },
  AC11: {
    shortDescription: "Thoroughfare Type Change",
    longDescription:
      'The thoroughfare (street) leading or trailing type was added or changed, such as from "St" to "Rd."',
  },
  AC12: {
    shortDescription: "Thoroughfare Directional Change",
    longDescription:
      'The thoroughfare (street) pre-directional or post-directional was added or changed, such as from "N" to "NW."',
  },
  AC13: {
    shortDescription: "Sub Premise Type Change",
    longDescription:
      "The sub premise (suite) type was added or changed, such as from “STE” to “APT.”",
  },
  AC14: {
    shortDescription: "Sub Premise Number Change",
    longDescription:
      "The sub premise (suite) unit number was added or changed.",
  },
  AC15: {
    shortDescription: "Double Dependent Locality Change",
    longDescription: "The double dependent locality was added or changed.",
  },
  AC16: {
    shortDescription: "SubAdministrative Area Change",
    longDescription: "The subadministrative area was added or changed.",
  },
  AC17: {
    shortDescription: "SubNational Area Change",
    longDescription: "The subnational area was added or changed.",
  },
  AC18: {
    shortDescription: "PO Box Change",
    longDescription: "The PO Box was added or changed.",
  },
  AC19: {
    shortDescription: "Premise Type Change",
    longDescription: "The premise type was added or changed.",
  },
  AC20: {
    shortDescription: "House Number Change",
    longDescription: "The house number was changed.",
  },
  AC22: {
    shortDescription: "Organization Change",
    longDescription: "The organization was added or changed.",
  },
  ES01: {
    shortDescription: "Valid Email",
    longDescription: "This email was confirmed to be a valid email.",
  },
  ES02: {
    shortDescription: "Invalid Email",
    longDescription: "This email was confirmed to be an invalid email.",
  },
  ES03: {
    shortDescription: "Unknown Email",
    longDescription:
      "This email's status is unknown due to unknown external factors. Please try again another time.",
  },
  ES04: {
    shortDescription: "Mobile Email Address",
    longDescription:
      "The domain name was identified as a mobile email address and classified as not deliverable by the FCC.",
  },
  ES05: {
    shortDescription: "Disposable Domain",
    longDescription:
      "The domain name of the submitted email was identified as a disposable domain.",
  },
  ES06: {
    shortDescription: "Spamtrap Domain",
    longDescription:
      "The domain of the submitted email was identified as a spamtrap. Mailing to this domain could result in the sender being blacklisted.",
  },
  ES07: {
    shortDescription: "Accept All Server",
    longDescription:
      "The mail server is an accept all server. Accept-All domains are set in a way that makes all emails seem valid.",
  },
  ES08: {
    shortDescription: "Role Address",
    longDescription:
      "This Email address was created as a group, ex: sales@, support@, or postmaster@.",
  },
  ES09: {
    shortDescription: "Protected Mailbox Caution",
    longDescription:
      "The mail provider for this email address may be quick to classify senders as spam and will not respond to our requests. Mailbox validation is not possible at this time and the mailbox may or may not exist. We recommend proceeding with caution if emailing numerous records to this mail domain.",
  },
  ES10: {
    shortDescription: "Syntax Changed",
    longDescription: "The syntax of the submitted email address was changed.",
  },
  ES11: {
    shortDescription: "Top Level Domain Changed",
    longDescription:
      "The top-level domain of the submitted email address was changed.",
  },
  ES12: {
    shortDescription: "Domain Changed (Spelling)",
    longDescription:
      "The domain of the submitted email address was corrected for spelling.",
  },
  ES13: {
    shortDescription: "Domain Changed (Update)",
    longDescription:
      "The domain of the submitted email address was updated due to a domain name change.",
  },
  ES20: {
    shortDescription: "Verify (Precision: Domain Result)",
    longDescription:
      "The email is considered valid, but did not have the mailbox verified and not found in our mailbox database.",
  },
  ES21: {
    shortDescription: "Verify (Precision: Cached Mailbox Result)",
    longDescription:
      "The email status was found in our database of cached emails.",
  },
  ES22: {
    shortDescription: "Verify (Precision: Real-time Mailbox Result)",
    longDescription: "The mailbox validation was performed in real-time.",
  },
  ES23: {
    shortDescription: "Verify (Precision: Unicode Result)",
    longDescription:
      "Unicode Detected: We do not support Unicode at this time for real-time mailbox validation. Domain and cache check only.",
  },
  ES24: {
    shortDescription: "Verify (Precision: Pending Mailbox Result)",
    longDescription:
      "The mail provider has been known to send a delayed response so it is possible that the pending status will change within the next 24 hours. You may want to resubmit this input at a later time as an update may be possible.",
  },
  ES30: {
    shortDescription: "Privacy Flag (TLD)",
    longDescription: "The top-level domain may be sensitive to privacy laws.",
  },
  ES31: {
    shortDescription: "Suspicious Characters",
    longDescription:
      "This email address has suspicious characters or characters which are not in the ASCII character set.",
  },
  EE01: {
    shortDescription: "Syntax Error",
    longDescription: "There is a syntax error in the submitted email address.",
  },
  EE02: {
    shortDescription: "A Domain Not Found",
    longDescription: "A domain of the submitted email address was not found.",
  },
  EE03: {
    shortDescription: "Mail Server Not Found",
    longDescription:
      "The mail server of the submitted email address was not found.",
  },
  EE04: {
    shortDescription: "Invalid Mailbox",
    longDescription: "An invalid mailbox was detected (i.e. noreply).",
  },
  EE05: {
    shortDescription: "Email Object not Initialized",
    longDescription:
      "Email Object was not initialized properly. Please review your code and data files.",
  },
  GS01: {
    shortDescription: "Geocoded to Street Level",
    longDescription:
      "The record was coded to the street level (Zip+4 for US, full postal code for CA).",
  },
  GS02: {
    shortDescription: "Geocoded to the Neighborhood Level",
    longDescription:
      "The record was geocoded down to neighborhood level (Zip+2 for US).",
  },
  GS03: {
    shortDescription: "Geocoded to Community Level",
    longDescription:
      "The record was coded to the community level (ZIP centroid for US, 3-digit postal code for CA).",
  },
  GS04: {
    shortDescription: "Geocoded to State Level",
    longDescription:
      "The record was geocoded to the state (administrative area) level.",
  },
  GS05: {
    shortDescription: "Geocoded to Rooftop Level",
    longDescription:
      "The record was geocoded down to the rooftop level, meaning the point is within the property boundaries, usually the center.",
  },
  GS06: {
    shortDescription: "Geocoded to Interpolated Rooftop Level",
    longDescription:
      "The record was geocoded down to the rooftop level using interpolation (educated estimations using street coordinates). The point may be in or close to the property boundaries.",
  },
  GS07: {
    shortDescription: "Records Found",
    longDescription:
      "The service successfully reverse geocoded the input coordinates and returned addresses.",
  },
  GS10: {
    shortDescription: "Wire Center Lat/Long",
    longDescription:
      "The latitude and longitude are based off of the wire center of the phone number.",
  },
  GE01: {
    shortDescription: "Invalid Postal Code",
    longDescription:
      "The submitted postal code is not in a valid format. Not to be confused with the GE01 Transmission result code.",
  },
  GE02: {
    shortDescription: "Postal Code Coordinates Not Found in Database",
    longDescription:
      "The submitted postal code coordinates were not found in the Geocode database. Not to be confused with the GE02 Transmission result code.",
  },
  GE03: {
    shortDescription: "Demo Mode",
    longDescription:
      "Geocoder is in Demo mode and a zip code outside the Demo range was detected.",
  },
  GE04: {
    shortDescription: "Data Files Expired",
    longDescription:
      "Geocoder data files are expired. Please update with the latest data files.",
  },
  GE05: {
    shortDescription: "License Not Enabled For Country",
    longDescription:
      "Geocoding for the country of input record is disabled for your License Key. Please contact your sales representative to enable.",
  },
  GE50: {
    shortDescription: "Invalid Latitude/Longitude",
    longDescription:
      "The submitted latitude/longitude was not valid. The service only accepts geo-coordinates in decimal formats.",
  },
  GE51: {
    shortDescription: "No Points Found",
    longDescription:
      "No points were found within the specified distance or specified coordinates are not in an area covered by Reverse Geocode.",
  },
  GE52: {
    shortDescription: "Out of Region (Deprecated)",
    longDescription:
      "The submitted latitude/longitude was not in the U.S. and no addresses were returned. (Deprecated)",
  },
  GE53: {
    shortDescription: "Invalid LookUpList",
    longDescription: "One or more of the input MAKs was not valid.",
  },
  GE54: {
    shortDescription: "Long Running Query",
    longDescription: "Could not return a response before service timed out.",
  },
  AV11: {
    shortDescription: "Administrative Area Partial",
    longDescription:
      "The address has been partially verified to the Administrative Area (State) Level, which is NOT the highest level possible with the reference data.",
  },
  AV12: {
    shortDescription: "Locality Partial",
    longDescription:
      "The address has been partially verified to the Locality (City) Level, which is NOT the highest level possible with the reference data.",
  },
  AV13: {
    shortDescription: "Thoroughfare Partial",
    longDescription:
      "The address has been partially verified to the Thoroughfare (Street) Level, which is NOT the highest level possible with the reference data.",
  },
  AV14: {
    shortDescription: "Premise Partial",
    longDescription:
      "The address has been partially verified to the Premise (House or Building) Level, which is NOT the highest level possible with the reference data.",
  },
  AV21: {
    shortDescription: "Administrative Area Full",
    longDescription:
      "The address has been verified to the Administrative Area (State) Level, which is the highest level possible with the reference data.",
  },
  AV22: {
    shortDescription: "Locality Full",
    longDescription:
      "The address has been verified to the Locality (City) Level, which is the highest level possible with the reference data.",
  },
  AV23: {
    shortDescription: "Thoroughfare Full",
    longDescription:
      "The address has been verified to the Thoroughfare (Street) Level, which is the highest level possible with the reference data.",
  },
  AV24: {
    shortDescription: "Premises Full",
    longDescription:
      "The address has been verified to the Premise (House or Building) Level, which is the highest level possible with the reference data.",
  },
  AV25: {
    shortDescription: "SubPremises Full",
    longDescription:
      "The address has been verified to the SubPremise (Suite) or PO Box Level, which is the highest level possible with the reference data.",
  },
  M: {
    shortDescription: "Multiple Matches",
    longDescription:
      "More than one record matches the address and there is not enough information available in the input address to break the tie between multiple records. Passing more complete information, such as city names or urbanization names, can help reduce the number of multiple match errors.",
  },
  N: {
    shortDescription: "No Street Data for Zip",
    longDescription:
      "The Zip Code exists but no streets begin with the same letter in that Zip Code.",
  },
  R: {
    shortDescription: "Range Error",
    longDescription:
      "The address was found but the street number in the input address was not between the low and high range in the CASS database.",
  },
  T: {
    shortDescription: "Component Error",
    longDescription:
      'Either the directionals or the suffix field did not match the CASS database, and there was more than one choice for correcting the address. For example, if the given address was "100 Main St" and the only addresses found were "100 E Main St" and 100 Main Ave" the error code "T" would be returned because we do not know whether to add the directional "E" or to change the suffix to "Ave".',
  },
  U: {
    shortDescription: "Unknown Street",
    longDescription:
      "An exact street name match could not be found and phonetically matching the street name resulted in either no matches or matches to more than one street name.",
  },
  X: {
    shortDescription: "Non-Deliverable Address or Address Not Coded",
    longDescription:
      "The physical location exists but there are no homes on this street. One reason might be that there are railroad tracks or a river running alongside this street, as they would prevent construction of homes in this location or Check the Error code and/or DPV Footnotes for more information.",
  },
  Z: {
    shortDescription: "Invalid Zip Code",
    longDescription:
      "The Zip Code does not exist and could not be determined by the city and state.",
  },
  C: {
    shortDescription: "Canadian Postal Code",
    longDescription:
      "The Zip Code matches the format characteristics of a Canadian Postal Code.",
  },
  W: {
    shortDescription: "EWS File Record",
    longDescription:
      "The Zip Code was found in the Early Warning System Data. These are new addresses scheduled to be included in the next USPS national database.",
  },
  D: {
    shortDescription: "Demo Mode",
    longDescription:
      'If processing with the demo CASS database, records not in the state of Nevada will be coded with "D".',
  },
  E: {
    shortDescription: "Expired Database",
    longDescription: "The CASS database has expired.",
  },
  S: {
    shortDescription: "Standardized but Not Coded",
    longDescription:
      'Standardization means that some conversion was done on the address (for example, changing "Post Office Box" to "PO Box").',
  },
  V: {
    shortDescription: "Street Number Validated to DPV Level",
    longDescription:
      "This record has been DPV validated. You can check the DPV Footnotes for more information about the level of validation.",
  },
  "7": {
    shortDescription: "Multiple Matches",
    longDescription:
      "There were multiple matches for the address that were all in the same Zip Code and Carrier Route. The returned Zip Code and Carrier Route will be correct but you will not get any Plus 4 information.",
  },
  "9": {
    shortDescription: "Fully Coded",
    longDescription: "The address was fully CASS coded.",
  },
  A: {
    shortDescription: "COA Match",
    longDescription:
      "The input record matched to a business, individual, or family type master file record. A new address could be furnished.",
  },
  "00": {
    shortDescription: "No Match",
    longDescription:
      "The input record COULD NOT BE matched to a master file record. A new address could not be furnished.",
  },
  "01": {
    shortDescription: "Foreign Move",
    longDescription:
      "The input record matched to a business, individual, or family type master file record but the new address was outside USPS delivery area.",
  },
  "02": {
    shortDescription: "Moved Left No Address",
    longDescription:
      "The input record matched to a business, individual, or family type master file record and the new address was not provided to USPS.",
  },
  "03": {
    shortDescription: "Box Closed No Order (BCNO)",
    longDescription:
      "The input record matched to a business, individual, or family type master file record which contains an old address of PO BOX that has been closed without a forwarding address provided.",
  },
  "04": {
    shortDescription: "Street Address with Secondary",
    longDescription:
      "In the STANDARD mode utilizing Family matching logic, the input record matched to a family record type on the master file with an old address that contained secondary information which obtained a ZIP+4 street level match. The input record does not contain secondary information...",
  },
  "05": {
    shortDescription: "New 11-digit DPBC is Ambiguous",
    longDescription:
      "The input record matched to a business, individual, or family type master file record. The new address on the master file record could not be converted to a deliverable address because the DPBC represents more than one delivery point.",
  },
  "06": {
    shortDescription: "Conflicting Directions: Middle Name Related",
    longDescription:
      "There is more than one COA (individual or family type) record for the match algorithm and the middle names or initials on the COAs are different. Therefore, a single match result could not be determined.",
  },
  "07": {
    shortDescription: "Conflicting Directions: Gender Related",
    longDescription:
      "There is more than one COA (individual or family type) record for the match algorithm and the genders of the names on the COAs are different. Therefore, a single match result could not be determined.",
  },
  "08": {
    shortDescription: "Other Conflicting Instructions",
    longDescription:
      "The input record matched to two master file (business, individual, or family type) records. The two records in the master file were compared and due to differences in the new addresses, a match could not be made.",
  },
  "09": {
    shortDescription: "High-rise Default",
    longDescription:
      "The input record matched to a family record on the master file from a High-rise address ZIP+4 coded to the building default. This address match situation requires individual name matching logic to obtain a match and individual names do not match.",
  },
  "10": {
    shortDescription: "Rural Default",
    longDescription:
      "The input record matched to a family record on the master file from a Rural Route or Highway Contract Route address ZIP+4 coded to the route default. This address situation requires individual name matching logic to obtain a match and individual names do not match.",
  },
  "11": {
    shortDescription: "Insufficient COA Name for Match",
    longDescription:
      "There is a master file (individual or family type) record with the same surname and address but there is insufficient name information on the master file record to produce a match using individual matching logic.",
  },
  "12": {
    shortDescription: "Middle Name Test Failed",
    longDescription:
      "The input record matched to an individual or family record on the master file with the same address and surname. However, a match cannot be made because the input name contains a conflict with the middle name or initials on the master file record.",
  },
  "13": {
    shortDescription: "Gender Test Failed",
    longDescription:
      "The input record matched to a master file (individual or family type) record. A match cannot be made because the gender of the name on the input record conflicts with the gender of the name on the master file record.",
  },
  "14": {
    shortDescription: "New Address Would Not Convert",
    longDescription:
      "The input record matched to a master file (business, individual, or family type) record. The new address could not be converted to a deliverable address.",
  },
  "15": {
    shortDescription: "Individual Name Insufficient",
    longDescription:
      "There is a master file record with the same address and surname. A match cannot be made because the input record does not contain a first name or contains initials only.",
  },
  "16": {
    shortDescription: "Secondary Number Discrepancy",
    longDescription:
      "The input record matched to a street level individual or family type record. However, a match is prohibited based on I of the following reasons: 1) There is conflicting secondary information on the input and master file record; 2) the input record contained secondary information and matched...",
  },
  "17": {
    shortDescription: "Other Insufficient Name",
    longDescription:
      "The input record matched to an individual or family master file record. The input name is different or not sufficient enough to produce a match.",
  },
  "18": {
    shortDescription: "General Delivery",
    longDescription:
      "The input record matched to a family record on the master file from a General Delivery address. This address situation requires individual name matching logic to obtain a match and individual names do not match.",
  },
  "19": {
    shortDescription: "New Address not ZIP + 4 coded or DPV confirmed.",
    longDescription:
      "There is a change of address on file but the new address cannot be ZIP + 4 coded and therefore there is no 11-digit DPBC to store or return, the new address primary number cannot be confirmed on DPV or the new address is temporary.",
  },
  "20": {
    shortDescription: "Conflicting Directions after re-chaining",
    longDescription:
      "Multiple master file records were potential matches for the input record. The master file records contained different new addresses and a single match result could not be determined.",
  },
  "66": {
    shortDescription: "Daily Delete",
    longDescription:
      "The input record matched to a business, individual, or family type master file record with an old address that is present in the daily delete file. The presence of an address in the daily delete file means that a COA with this address is pending deletion from the master file and that no mail may be forwarded from this address.",
  },
  "77": {
    shortDescription: "ANKLink Primary Return Code",
    longDescription:
      "Indicates that ANKlink has provided the move date, but not address, for a move that occurred between 19 and 48 months ago.",
  },
  "91": {
    shortDescription: "Secondary Number dropped from COA",
    longDescription:
      "The input record matched to a master file record. The master file record had a secondary number and the input address did not. Please Note: This return code is derived from Individual matching logic only. If this return code is achieved then no other matching attempts are permitted regardless of the PROCESSING mode.",
  },
  "92": {
    shortDescription: "Secondary Number Dropped from input address",
    longDescription:
      "The input record matched to a master file record, but the input address had a secondary number and the master file record did not. The record is a ZIP + 4 street level match. Please Note: This return code is derived from individual matching logic only. If this return code is achieved then no other matching attempts are permitted...",
  },
  MS01: {
    shortDescription: "Unique Record",
    longDescription: "The record did not match any other records.",
  },
  MS02: {
    shortDescription: "Has Duplicates",
    longDescription:
      "The record matched other records and was tagged as the output record.",
  },
  MS03: {
    shortDescription: "Is Duplicate",
    longDescription:
      "The record matched other records and was tagged as a duplicate.",
  },
  MS04: {
    shortDescription: "Record Suppressed",
    longDescription: "ETL Only. The source record was suppressed.",
  },
  MS05: {
    shortDescription: "Record Not Intersected",
    longDescription: "ETL Only. The source record was not intersected.",
  },
  MS06: {
    shortDescription: "Match: Rule 1",
    longDescription: "Records were matched by matchcode combination 1.",
  },
  MS07: {
    shortDescription: "Match: Rule 2",
    longDescription: "Records were matched by matchcode combination 2.",
  },
  MS08: {
    shortDescription: "Match: Rule 3",
    longDescription: "Records were matched by matchcode combination 3.",
  },
  MS09: {
    shortDescription: "Match: Rule 4",
    longDescription: "Records were matched by matchcode combination 4.",
  },
  MS10: {
    shortDescription: "Match: Rule 5",
    longDescription: "Records were matched by matchcode combination 5.",
  },
  MS11: {
    shortDescription: "Match: Rule 6",
    longDescription: "Records were matched by matchcode combination 6.",
  },
  MS12: {
    shortDescription: "Match: Rule 7",
    longDescription: "Records were matched by matchcode combination 7.",
  },
  MS13: {
    shortDescription: "Match: Rule 8",
    longDescription: "Records were matched by matchcode combination 8.",
  },
  MS14: {
    shortDescription: "Match: Rule 9",
    longDescription: "Records were matched by matchcode combination 9.",
  },
  MS15: {
    shortDescription: "Match: Rule 10",
    longDescription: "Records were matched by matchcode combination 10.",
  },
  MS16: {
    shortDescription: "Match: Rule 11",
    longDescription: "Records were matched by matchcode combination 11.",
  },
  MS17: {
    shortDescription: "Match: Rule 12",
    longDescription: "Records were matched by matchcode combination 12.",
  },
  MS18: {
    shortDescription: "Match: Rule 13",
    longDescription: "Records were matched by matchcode combination 13.",
  },
  MS19: {
    shortDescription: "Match: Rule 14",
    longDescription: "Records were matched by matchcode combination 14.",
  },
  MS20: {
    shortDescription: "Match: Rule 15",
    longDescription: "Records were matched by matchcode combination 15.",
  },
  MS21: {
    shortDescription: "Match: Rule 16",
    longDescription: "Records were matched by matchcode combination 16.",
  },
  MS30: {
    shortDescription: "Suppressor Record",
    longDescription: "ETL Only. The lookup record suppressed a source record.",
  },
  MS31: {
    shortDescription: "Intersector Record",
    longDescription: "ETL Only. The lookup record intersected a source record.",
  },
  NS01: {
    shortDescription: "Name Parsed",
    longDescription: "Name parsing was successful.",
  },
  NS02: {
    shortDescription: "Error Parsing",
    longDescription:
      "An error was detected. Please check for a name error code.",
  },
  NS03: {
    shortDescription: "First Name Spelling Corrected",
    longDescription: "The spelling in the first name field was corrected.",
  },
  NS04: {
    shortDescription: "First Name 2 Spelling Corrected",
    longDescription:
      "The spelling in the second first name field was corrected.",
  },
  NS05: {
    shortDescription: "First Name 1 Found",
    longDescription:
      "FirstName1 was found in our census table of names. Very likely to be a real first name.",
  },
  NS06: {
    shortDescription: "Last Name 1 Found",
    longDescription:
      "LastName1 was found in our census table of names. Very likely to be a real last name.",
  },
  NS07: {
    shortDescription: "First Name 2 Found",
    longDescription:
      "FirstName2 was found in our census table of names. Very likely to be a real first name.",
  },
  NS08: {
    shortDescription: "Last Name 2 Found",
    longDescription:
      "LastName2 was found in our census table of names. Very likely to be a real last name.",
  },
  NS09: {
    shortDescription: "Dual-name Parsed",
    longDescription:
      "Input has dual-name contents and was split into two single-name outputs.",
  },
  NS99: {
    shortDescription: "Company Name Standardized",
    longDescription: "The company name was standardized.",
  },
  NE01: {
    shortDescription: "Unrecognized Format",
    longDescription:
      "Format of Input string was not recognized or too long to represent a valid name.",
  },
  NE02: {
    shortDescription: "Multiple First Names Detected",
    longDescription:
      "Multiple first names were detected and could not be accurately genderized.",
  },
  NE03: {
    shortDescription: "Vulgarity Detected",
    longDescription: "A vulgarity was detected in the name.",
  },
  NE04: {
    shortDescription: "Suspicious Word Detected",
    longDescription:
      'The name contained words found on the list of nuisance names, such as "Mickey Mouse."',
  },
  NE05: {
    shortDescription: "Company Name Detected",
    longDescription:
      "The name contained words normally found in a company name.",
  },
  NE06: {
    shortDescription: "Non-Alphabetic Character Detected",
    longDescription: "The name contained a non-alphabetic character.",
  },
  NE07: {
    shortDescription: "Multiple Names Split Detected",
    longDescription:
      "Multiple names sets were detected when split, only the first two sets are parsed.",
  },
  NE08: {
    shortDescription: "Unicode/Non-Latin Name Input",
    longDescription:
      "Unicode characters detected on input. We do not support Unicode at this time; the input is returned as-is.",
  },
  NE09: {
    shortDescription: "Multiple Formats Detected",
    longDescription: "Multiple Formats - Forward and Inverse - Detected.",
  },
  NE10: {
    shortDescription: "Missing Minimum Name",
    longDescription:
      "Minimum requirements for the name input data are not met. The name must have at least one Alpha Character to be parsed.",
  },
  NE99: {
    shortDescription: "Company Standardization Not Needed",
    longDescription:
      "Company name standardization was attempted but did not produce a different result.",
  },
  DA00: {
    shortDescription: "Address Appended",
    longDescription: "An address was changed or appended.",
  },
  DA01: {
    shortDescription: "City/State Append from Phone",
    longDescription:
      "A city or state was appended from a phone number wire center.",
  },
  DA10: {
    shortDescription: "Name Appended",
    longDescription: "A full name was changed or appended.",
  },
  DA20: {
    shortDescription: "Company Appended",
    longDescription: "A company name was changed or appended.",
  },
  DA30: {
    shortDescription: "Phone Appended",
    longDescription: "A phone number was changed or appended.",
  },
  DA40: {
    shortDescription: "Email Appended",
    longDescription: "An email address was changed or appended.",
  },
  DA50: {
    shortDescription: "Web Address Appended",
    longDescription: "A web address was changed or appended.",
  },
  DA60: {
    shortDescription: "Stock Ticker Appended",
    longDescription: "A stock ticker was changed or appended.",
  },
  VR01: {
    shortDescription: "Name and Address Match",
    longDescription: "The name and address match.",
  },
  VR02: {
    shortDescription: "Name and Phone Match",
    longDescription: "The name and phone match.",
  },
  VR03: {
    shortDescription: "Name and Email Match",
    longDescription: "The name and email match.",
  },
  VR04: {
    shortDescription: "Address and Phone Match",
    longDescription: "The address and phone match.",
  },
  VR05: {
    shortDescription: "Address and Email Match",
    longDescription: "The address and email match.",
  },
  VR06: {
    shortDescription: "Phone and Email Match",
    longDescription: "The phone and email match.",
  },
  VR07: {
    shortDescription: "Company and Address Match",
    longDescription: "The company and address match.",
  },
  VR08: {
    shortDescription: "Company and Phone Match",
    longDescription: "The company and phone match.",
  },
  VR09: {
    shortDescription: "Company and Email Match",
    longDescription: "The company name and email match.",
  },
  VR10: {
    shortDescription: "Company and Name Match",
    longDescription: "The company and name match.",
  },
  VR11: {
    shortDescription: "Name and SSN Match",
    longDescription: "Matched the name field to the Social Security Number.",
  },
  VS00: {
    shortDescription: "Contact Record Not Found",
    longDescription:
      "The record was not found in our contact database. We are unable to verify any information about the residents of this address.",
  },
  VS01: {
    shortDescription: "Historical Address Match",
    longDescription:
      'The current address is outdated and a newer address match was found. Use the "Move" action to get the latest address.',
  },
  VS02: {
    shortDescription: "Partial Address Match",
    longDescription:
      "A match was made to a partial address. This could be due to matching the street address but not to the suite.",
  },
  VS12: {
    shortDescription: "Last Name Match",
    longDescription: "A match was made to the last name only.",
  },
  VS13: {
    shortDescription: "First Name Match",
    longDescription: "A match was made to the first name only.",
  },
  VS22: {
    shortDescription: "Partial Company Name Match",
    longDescription: "A match was made to a partial company name.",
  },
  VS30: {
    shortDescription: "Phone Not Found",
    longDescription: "A phone number was not found in the reference data.",
  },
  VS31: {
    shortDescription: "Historical Phone Match",
    longDescription:
      'The current phone number is outdated and a newer phone number match was found. Use the "Append" action to get the latest phone number.',
  },
  VS40: {
    shortDescription: "Email Not Found",
    longDescription: "An email address was not found in the reference data.",
  },
  VS41: {
    shortDescription: "Historical Email Address",
    longDescription:
      'The current email address is outdated and a newer email address match was found. Use the "Append" action to get the latest email address.',
  },
  VS50: {
    shortDescription: "Last4 Only Match",
    longDescription:
      "The name only matched to the last 4 digits of the Social Security Number.",
  },
  PS01: {
    shortDescription: "Valid Phone",
    longDescription: "The phone number is valid.",
  },
  PS02: {
    shortDescription: "7-Digit Match",
    longDescription:
      "The first 7-digits of the phone number have been verified, but activity cannot be confirmed.",
  },
  PS03: {
    shortDescription: "Corrected Area Code",
    longDescription:
      "NewAreaCode contains corrected area code that was changed according to the postal code it falls into.",
  },
  PS04: {
    shortDescription: "Demo Mode",
    longDescription:
      "Demo mode is active and the phone number is outside the range of phone numbers allowed by the Demo.",
  },
  PS05: {
    shortDescription: "Database Expired",
    longDescription: "The phone database is expired. Please update your data.",
  },
  PS06: {
    shortDescription: "Updated Area Code",
    longDescription:
      "The area code was changed due to an area code split. The updated code is located within NewAreaCode.",
  },
  PS07: {
    shortDescription: "Cellular Line",
    longDescription:
      "On activation, the exchange type of the phone number was designated as a cellular number, but current status cannot be confirmed.",
  },
  PS08: {
    shortDescription: "Land Line",
    longDescription:
      "On activation, the exchange type of the phone number was designated as a land line, but current status cannot be confirmed.",
  },
  PS09: {
    shortDescription: "VOIP Line",
    longDescription:
      "On activation, the exchange type of the phone number was designated as a VOIP line, but current status cannot be confirmed.",
  },
  PS10: {
    shortDescription: "Residential Number",
    longDescription: "Phone number found in Personator database.",
  },
  PS11: {
    shortDescription: "Business Number",
    longDescription: "Phone number found in Business database.",
  },
  PS12: {
    shortDescription: "SOHO Number",
    longDescription:
      "The phone number belongs to a small office or home office.",
  },
  PS13: {
    shortDescription: "Toll Free Number",
    longDescription: "The phone number is a toll free number.",
  },
  PS14: {
    shortDescription: "Special Number",
    longDescription:
      "This is a phone number with premium service, data, internet access, etc. which all incur a higher charge rate.",
  },
  PS15: {
    shortDescription: "Misc Type",
    longDescription:
      "The phone number is used for other services (calling cards, national numbers, directory assistance, mass communications, etc.)",
  },
  PS16: {
    shortDescription: "Live Status Unknown",
    longDescription:
      "HLR is unable to determine if the Phone Number is live due to external errors. Please try again at another time.",
  },
  PS17: {
    shortDescription: "Live number",
    longDescription:
      "Phone is live, callable and/or able to receive SMS as determined by HLR.",
  },
  PS18: {
    shortDescription: "Do Not Call",
    longDescription:
      "The owner of this phone number has opted out of Melissa's call lists. This has no relation to the US National Do Not Call list.",
  },
  PS19: {
    shortDescription: "Disposable Phone Flag",
    longDescription: "Numbers intended for temporary/short-term use.",
  },
  PS20: {
    shortDescription: "Low Confidence",
    longDescription:
      "Number exists within a block of registered phone numbers.",
  },
  PS21: {
    shortDescription: "Medium Confidence",
    longDescription:
      "Number was found to already be validated in our phone database.",
  },
  PS22: {
    shortDescription: "High Confidence",
    longDescription: "Number was verified against current dialing equipment.",
  },
  PS30: {
    shortDescription: "Premium Timeout",
    longDescription:
      "Querying Premium has timed out, but has continued to run in the background. Query later to obtain the cached results.",
  },
  PS31: {
    shortDescription: "CallerID Timeout",
    longDescription:
      "Querying CallerID has timed out, but has continued to run in the background. Query later to obtain the cached results.",
  },
  PE01: {
    shortDescription: "Invalid Phone",
    longDescription:
      "The area code/phone number does not exist in our database or contains non-numbers.",
  },
  PE02: {
    shortDescription: "Blank Phone",
    longDescription: "The phone number is blank.",
  },
  PE03: {
    shortDescription: "Bad Phone",
    longDescription: "The phone number has too many or too few digits.",
  },
  PE04: {
    shortDescription: "Multiple Match",
    longDescription:
      "Two or more possible area codes are available as a fix, and their distance is too close to choose one over the other.",
  },
  PE05: {
    shortDescription: "Bad Prefix/Prefix +1",
    longDescription:
      "The phone prefix or first 7-digits do not exist in our database.",
  },
  PE06: {
    shortDescription: "Bad Postal Code",
    longDescription: "The input postal code is invalid.",
  },
  PE08: {
    shortDescription: "No Country Input",
    longDescription:
      'Global Phone Object Only. The input country is blank, and the phone number has no "+" sign.',
  },
  PE09: {
    shortDescription: "Out of Range Suffix",
    longDescription:
      "Global Phone Object Only. The subscriber's phone number suffix is out of range.",
  },
  PE10: {
    shortDescription: "Invalid Input Country",
    longDescription:
      "Global Phone Object Only. The input country is not valid.",
  },
  PE11: {
    shortDescription: "Disconnected",
    longDescription: "Phone number is no longer in service.",
  },
  QS01: {
    shortDescription: "Empty Value",
    longDescription: "The value is empty or contains only spaces.",
  },
  QS02: {
    shortDescription: "NULL Value",
    longDescription: "The value is NULL.",
  },
  QS03: {
    shortDescription: "Default Value",
    longDescription: "The value is equal to the user-specified default.",
  },
  QS04: {
    shortDescription: "Non-Printing Characters",
    longDescription:
      "The value contains non-printing characters (e.g., printer control characters, etc.)",
  },
  QS05: {
    shortDescription: "Diacritic Characters",
    longDescription:
      "The value contains diacritic characters (e.g., accented characters.)",
  },
  QS06: {
    shortDescription: "Non-English Characters",
    longDescription: "The value contains non-English characters.",
  },
  QS07: {
    shortDescription: "Decorative Characters",
    longDescription:
      "The value contains decorative characters. Decorative characters are tabs, commas, or double quotes, found in the beginning or ending of the value. This may indicate an import issue where delimiters made their way into the value being evaluated.",
  },
  QS08: {
    shortDescription: "Alphabetic Characters",
    longDescription: "The value contains only alphabetic characters.",
  },
  QS09: {
    shortDescription: "Numeric Characters",
    longDescription: "The value contains only numeric characters.",
  },
  QS10: {
    shortDescription: "Alphabetic and Numeric Characters",
    longDescription:
      "The value contains both alphabetic and numeric characters.",
  },
  QS11: {
    shortDescription: "Upper-Case Alphabetic Characters",
    longDescription:
      "The value contains only upper-case alphabetic characters, and may contain non-alphabetic characters.",
  },
  QS12: {
    shortDescription: "Lower-Case Alphabetic Characters",
    longDescription:
      "The value contains only lower-case alphabetic characters, and may contain non-alphabetic characters.",
  },
  QS13: {
    shortDescription: "Upper and Lower Alphabetic Characters",
    longDescription:
      "The value contains both upper and lower-case alphabetic characters, and may contain non-alphabetic characters.",
  },
  QS14: {
    shortDescription: "Single Space",
    longDescription: "Only a single space separates the words in the value.",
  },
  QS15: {
    shortDescription: "Multiple Spaces",
    longDescription: "Multiple spaces separate the words in the value.",
  },
  QS16: {
    shortDescription: "Leading Spaces",
    longDescription: "The value contains leading spaces.",
  },
  QS17: {
    shortDescription: "Trailing Spaces",
    longDescription: "The value contains trailing spaces.",
  },
  QS18: {
    shortDescription: "Profanity",
    longDescription: "The value contains profanity.",
  },
  QS19: {
    shortDescription: "2-digit Year",
    longDescription: "The date/time value lacks the year's century.",
  },
  QS20: {
    shortDescription: "Inconsistent Name",
    longDescription:
      "The name value contains a name where the order is inconsistent with the user-specified data type.",
  },
  QS21: {
    shortDescription: "Multiple Names",
    longDescription: "The name value contains more than one contact name.",
  },
  QS22: {
    shortDescription: "Suspicious Name",
    longDescription: "The name value contains a suspicious name.",
  },
  QS30: {
    shortDescription: "Non-Standard State/Province",
    longDescription:
      "The State/Province value contains a non-standard US state or Canadian province (i.e., not the official postal abbreviation).",
  },
  QS40: {
    shortDescription: "5-digit ZIP/Postal Code",
    longDescription:
      "The ZIP/Postal Code value has a 5-digit Zip Code with no Plus 4.",
  },
  QS50: {
    shortDescription: "Unrecognized Country ISO",
    longDescription:
      "The country value does not match any standard ISO country representation.",
  },
  QS60: {
    shortDescription: "Mobile Domain",
    longDescription: "The e-mail value contains a mobile (cell phone) domain.",
  },
  QS61: {
    shortDescription: "Spam Trap Domain",
    longDescription: "The e-mail value contains a known spam trap domain.",
  },
  QS62: {
    shortDescription: "Disposable Domain",
    longDescription: "The e-mail value contains a known 'disposable' domain.",
  },
  QS90: {
    shortDescription: "Embedded Row Delimiter",
    longDescription: "The record contained an embedded row delimiter.",
  },
  QS91: {
    shortDescription: "Missing Fields",
    longDescription: "Not all fields were present in the record.",
  },
  QS92: {
    shortDescription: "Extra Fields",
    longDescription: "Extra fields were present in the record.",
  },
  QE01: {
    shortDescription: "Illegal UTF-8 Byte Sequence",
    longDescription: "The value contains an illegal UTF-8 byte sequence.",
  },
  QE03: {
    shortDescription: "Invalid Integer",
    longDescription: "The value's integer value is invalid.",
  },
  QE04: {
    shortDescription: "Invalid Decimal",
    longDescription: "The value's decimal value is invalid.",
  },
  QE05: {
    shortDescription: "Invalid Floating Point",
    longDescription: "The value's floating point value is invalid.",
  },
  QE06: {
    shortDescription: "Invalid Date/Time",
    longDescription: "The value's date/time value is invalid.",
  },
  QE07: {
    shortDescription: "Invalid Boolean Value",
    longDescription: "The value's boolean value is invalid.",
  },
  QE08: {
    shortDescription: "Over Range",
    longDescription: "The value is above the user-specified range.",
  },
  QE09: {
    shortDescription: "Under Range",
    longDescription: "The value is below the user-specified range.",
  },
  QE10: {
    shortDescription: "Length Size Exceeded",
    longDescription: "The value's length exceeds the user-specified size.",
  },
  QE11: {
    shortDescription: "Precision Exceeded",
    longDescription:
      "The value's precision exceeds the user-specified precision.",
  },
  QE12: {
    shortDescription: "Precision Scale Exceeded",
    longDescription: "The value's precision exceeds the user-specified scale.",
  },
  QE13: {
    shortDescription: "No Regular Expression Match",
    longDescription:
      "The value does not match any of the user-specified regular expressions.",
  },
  QE14: {
    shortDescription: "Data Type Mismatch",
    longDescription:
      "The value is inconsistent with the user-specified DataType (e.g., an address field containing a phone number.)",
  },
  QE30: {
    shortDescription: "Unrecognized State/Province",
    longDescription: "The value contains an unrecognized state or province.",
  },
  QE40: {
    shortDescription: "Invalid ZIP Code",
    longDescription:
      "The value contains a US ZIP code that is not valid (only the 5-digit zip is validated in this way.) This is returned only when getting the results for a column with a data type set as DataTypeZipOrPostalCode.",
  },
  QE41: {
    shortDescription: "Invalid Postal Code",
    longDescription:
      "The value contains a Canadian Postal Code that is not valid. This is returned only when getting the results for a column with a data type set as DataTypeZipOrPostalCode.",
  },
  QE42: {
    shortDescription: "ZIP Code Mismatch",
    longDescription:
      "The value's Zip Code does not correctly correspond to the specified US State. This is returned only when getting the results for a column with a data type set as DataTypeStateOrProvince.",
  },
  QE43: {
    shortDescription: "Postal Code Mismatch",
    longDescription:
      "The value's Postal Code does not correctly correspond to the specified Canadian Province. This is returned only when getting the results for a column with a data type set as DataTypeStateOrProvince.",
  },
  QE50: {
    shortDescription: "Unrecognized Country",
    longDescription: "The value contains an unrecognized country name.",
  },
  QE60: {
    shortDescription: "Incorrect E-mail Syntax",
    longDescription:
      "The value contains an e-mail address with incorrect syntax.",
  },
  QE61: {
    shortDescription: "Misspelled Domain",
    longDescription: "The value contains an e-mail with a misspelled domain.",
  },
  QE70: {
    shortDescription: "Unrecognizable Phone",
    longDescription: "The value contains an unrecognizable phone number.",
  },
  QE90: {
    shortDescription: "Unbalanced Text Qualifiers",
    longDescription: "The record contained unbalanced text qualifiers.",
  },
  QE91: {
    shortDescription: "Un-escaped Text Qualifiers",
    longDescription: "The record contained un-escaped text qualifiers.",
  },
  SN01: {
    shortDescription: "Invalid SSN Format",
    longDescription: "The format of your Social Security Number was invalid.",
  },
  SN02: {
    shortDescription: "SSN not found in our records",
    longDescription:
      "The SSN was not found in the reference database. This indicates either a number not issued or a number that has been issued but is not available.",
  },
  SN03: {
    shortDescription: "SSN is on the DECEASED list",
    longDescription:
      "The SSN was found on the deceased list – no matching was made to the input name as this number is no longer active.",
  },
  SN04: {
    shortDescription: "SSN and FULL name match our records",
    longDescription:
      "The SSN matched to both the first and last name of the input record.",
  },
  SN05: {
    shortDescription: "SSN and LAST name match our records",
    longDescription:
      "The SSN and last name match, but the first names did not match.",
  },
  SN06: {
    shortDescription: "SSN and FIRST name match our records",
    longDescription:
      "The SSN and the first name matched, and first name could be female.",
  },
  SN07: {
    shortDescription: "SSN and NAME do NOT match our records",
    longDescription:
      "The SSN belongs to a name different from the one that was input.",
  },
  SN08: {
    shortDescription: "SSN and Last Name, First Name Initial match our records",
    longDescription:
      "The SSN number matched the last name and the first initial.",
  },
};
